/**
 * SamplePrep (Yes/No) for the Sample Prep Batch grid — decided by a FIXED formula on
 * the entered NTU (turbidity): NTU >= 1.0 → Yes, otherwise No; blank until a number
 * is typed. Was NTU > 1.0 — changed to >= on user request 2026-09-29, so exactly 1.0
 * now needs prep. Hard-coded on purpose (user 2026-08-14) — it does not read the ACT
 * config; the ACT-driven version is preserved in features/settings/act/actData.ts
 * (evalSamplePrep) for when ACT persistence lands.
 */
export function samplePrepFromNtu(ntu: string | number | null | undefined): '' | 'Yes' | 'No' {
  const n = typeof ntu === 'number' ? ntu : parseFloat(String(ntu ?? '').trim());
  if (!Number.isFinite(n)) return '';
  return n >= 1.0 ? 'Yes' : 'No';
}
